import {Component, input} from '@angular/core';
import {NgStyle} from "@angular/common";

export type CustomIconName = 'fa-triangle-exclamation' | 'fa-upload';

@Component({
  selector: 'custom-icon',
  imports: [
    NgStyle
  ],
  templateUrl: './custom-icon.html'
})
export class CustomIcon {
  iconName = input.required<CustomIconName>();
  size = input('20px');
}
